import React from 'react';

import Icon, { IconProps } from 'carbon-react/lib/components/icon/icon.component';
import Typography, { TypographyProps } from 'carbon-react/lib/components/typography';

import styles from './icon-message.scss';

export interface IconMessageProps extends TypographyProps {
  children: React.ReactNode;
  icon?: IconProps['type'];
  iconColor?: IconProps['color'];
}

export const IconMessage = ({ children, icon = 'info', iconColor = '#0060A7', ...props }: IconMessageProps) => {
  return (
    <Typography variant="p" className={styles.container} {...props}>
      <Icon type={icon} mr={1} color={iconColor} />
      {children}
    </Typography>
  );
};
